import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import AddPlaylistModalNew from './AddPlaylistModalNew';
import AddPlaylistModalClassic from './AddPlaylistModalClassic';

// The dark (#15171c) create-playlist modal restyle ships only to allow-listed
// new-UI users. Classic (production) users keep the legacy blue modal.
const AddPlaylistModal = (props) => (isNewUIEnabled()
  ? <AddPlaylistModalNew {...props} />
  : <AddPlaylistModalClassic {...props} />);

export default AddPlaylistModal;
